export const state = {
    user: null,
    token: {
        access: null,
        refresh: null
    },
    auto: false
};
